import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FieldId } from "./calculator.utility";
import { SummaryView } from "./common-components/SummaryView";
import { PaceTable } from "./common-components/PaceTable/PaceTable";
import { Pace } from "./pace-fns/pace-fns";
import { usePreferences, ThemeProps } from "./usePreferences";
import * as analytics from "./analytics";
import {
  useCalculatorState,
  updateCalculatorState,
} from "./CalculatorStateManager";
import { createLogAppState } from "./analytics.utils";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 100px 21px 0 21px;
  background: ${({ theme }: ThemeProps) => theme.palette.background};
  box-sizing: border-box;
  overflow-y: scroll;
`;

export const AnalysisView = () => {
  const calculatorStateManager = useCalculatorState();
  const [state, setState] = useState(
    calculatorStateManager.getCalculatorState()
  );
  const [preferences, _dispatch] = usePreferences();

  useEffect(() => {
    return calculatorStateManager.addStateListener(setState);
  }, []);

  const handlePaceChange = (pace: Pace) => {
    const pendingState = { ...state, pace };
    analytics.logEvent(
      "Analysis",
      "Pace Change",
      createLogAppState(pendingState)
    );
    calculatorStateManager.dispatch(
      updateCalculatorState({
        pendingState,
        fieldToCalculateId: FieldId.Time,
      })
    );
  };

  return (
    <Container theme={preferences.theme}>
      <SummaryView metrics={state} />
      <PaceTable metrics={state} onPaceChange={handlePaceChange} />
    </Container>
  );
};
